module.exports = __webpack_public_path__ + "img/anesthesiac.4a0384e1.jpg";